/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useTheme } from '@mui/material';

import LayoutServicePage from 'components/mui/Layouts/LayoutServicePage';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import SvgIcon from '@mui/material/SvgIcon';

import { ReactComponent as AppStoreIcon } from './icons/appStoreIcon.svg';
import { ReactComponent as GooglePlayIcon } from './icons/googlePlayIcon.svg';

const MobileNotSupported = () => {
  const {
    labelOptions: { appStoreDownloadLink, playMarketDownloadLink, logotype },
  } = useTheme();
  const { action } = useParams();

  return (
    <LayoutServicePage sx={{ textAlign: 'center', alignItems: 'center' }}>
      <img src={logotype.src} alt="logo" style={{ width: '30%', height: 55, margin: '20px auto 40px' }} />

      <Stack gap={0} flex={1} justifyContent="center" alignItems="center" component="main">
        <Typography sx={{ fontWeight: 'bold', fontSize: '32px', mb: 3 }}>
          {action === 'password_restored' ? 'You all set' : 'Your browser is not supported'}
        </Typography>
        {(appStoreDownloadLink || playMarketDownloadLink) && (
          <Stack sx={{ mb: 3 }}>
            <Typography sx={{ textTransform: 'uppercase', mb: 1, color: 'primary.main' }}>
              Please, install our mobile app
            </Typography>
            <Stack direction="row" gap={1}>
              {appStoreDownloadLink && (
                <Link href={appStoreDownloadLink}>
                  <SvgIcon component={AppStoreIcon} sx={{ width: 128, height: 42 }} inheritViewBox />
                </Link>
              )}
              {playMarketDownloadLink && (
                <Link href={playMarketDownloadLink}>
                  <SvgIcon component={GooglePlayIcon} sx={{ width: 128, height: 42 }} inheritViewBox />
                </Link>
              )}
            </Stack>
          </Stack>
        )}

        <Typography sx={{ color: 'text.secondary', px: 2 }}>
          Please open the app from your computer to have access to all accounting features.
        </Typography>
      </Stack>
    </LayoutServicePage>
  );
};

export default MobileNotSupported;
